import React, { memo } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { Paperclip, Sparkle } from '@phosphor-icons/react'
import { nodeCardClass, nodeChipClass, nodeHandleClass, nodeIcon, nodeTextClass, nodeTone } from '../../nodeCatalog'

const TYPE = 'generateDeck'
const Icon = nodeIcon(TYPE)

const GenerateDeckNode: React.FC<NodeProps> = ({ data, selected }) => {
  const config = data.generate_deck_config
  const mode = config?.mode || 'ai_generate'
  const isAttach = mode === 'attach_direct'

  const focusLabels: Record<string, string> = {
    pitch_deck: 'Pitch Deck',
    product_overview: 'Product Overview',
    case_study: 'Case Study',
    industry_analysis: 'Industry Analysis',
    custom: 'Custom',
  }
  const focusLabel = focusLabels[config?.content_focus || 'pitch_deck'] || 'Pitch Deck'

  return (
    <div className={nodeCardClass(TYPE, selected)}>
      <Handle
        type="target"
        position={Position.Top}
        className={nodeHandleClass(TYPE)}
      />
      <div className="flex items-center gap-2">
        <div className={nodeChipClass(TYPE)}>
          <Icon className={`w-4 h-4 ${nodeTextClass(TYPE)}`} />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`text-[10px] font-emphasis uppercase tracking-wider ${nodeTextClass(TYPE)}`}>Collaterals</p>
          <p className="text-sm font-medium text-foreground truncate">{data.label || 'Collateral'}</p>
        </div>
      </div>
      <div className="mt-2 pl-10 space-y-1">
        {isAttach ? (
          <div className="flex items-center gap-1">
            <Paperclip className={`w-3 h-3 ${nodeTextClass(TYPE)}`} />
            <span className={`text-[10px] font-medium ${nodeTextClass(TYPE)}`}>
              {config?.attached_material_id ? 'Material attached' : 'No material selected'}
            </span>
          </div>
        ) : (
          <>
            <p className="text-xs text-muted-foreground truncate">
              {config?.slide_count || 6} slides &middot; {focusLabel}
            </p>
            <div className="flex items-center gap-1">
              <Sparkle className={`w-3 h-3 ${nodeTextClass(TYPE)}`} />
              <span className={`text-[10px] font-medium ${nodeTextClass(TYPE)}`}>AI-Generated</span>
            </div>
          </>
        )}
      </div>
      {data._upstreamEnrichmentFields?.length > 0 && (
        <div className="mt-1.5 flex items-center gap-1 pl-10">
          <div className={`w-2 h-2 rounded-full animate-pulse ${nodeTone('enrichContacts').solid}`} />
          <span className={`text-[10px] font-medium ${nodeTextClass('enrichContacts')}`}>
            {data._upstreamEnrichmentFields.length} enrichment fields
          </span>
        </div>
      )}
      <Handle
        type="source"
        position={Position.Bottom}
        className={nodeHandleClass(TYPE)}
      />
    </div>
  )
}

export default memo(GenerateDeckNode)
